import { getDdCountryData } from "../CarrierMaster/CarrierContact/CarrierContactService";

export const getTextFromValue = (arr, valueKey) => {
  var i = null;
  for (i = 0; arr.length > i; i += 1) {
    if (arr[i].value === valueKey) {
      return arr[i].text;
    }
  }
  return "";
};

export const getValueFromText = (arr, textKey) => {
  var i = null;
  for (i = 0; arr.length > i; i += 1) {
    if (arr[i].text === textKey) {
      return arr[i].value.split('-')[0];
    }
  }
  return "";
};

export const getTextFromValueforPortPreQual = (arr, valueKey) => {
  valueKey = "P_" + valueKey;
  var i = null;
  for (i = 0; arr.length > i; i += 1) {
    if (arr[i].value.slice(0, 5) === valueKey) {
      return arr[i].text;
    }
  }
  return "";
};

export const getpreQualText = (
  originType,
  originValue,
  arrGeo,
  arrCountry,
  arrZone
) => {
  var ddList = [];
  var countryname = "";

  if (originType == "Geo") {
    ddList = arrGeo;
    return getTextFromValue(ddList, originValue);
  }
  if (originType == "Port") {
    ddList = arrZone;
    return getTextFromValueforPortPreQual(ddList, originValue);
  }
  if (originType == "Country") {
    ddList = arrCountry;
    return getTextFromValue(ddList, originValue);
  }
};

export const getDdRegionDataQualification = async () => {
  let regionData = await getDdCountryData();
  regionData = regionData.map((data) => ({
    geo: data["geo"],
    value: data["geo"],
  }));
  regionData = regionData.filter(
    (data, index, self) => index === self.findIndex((t) => t.geo === data.geo)
  );
  return regionData;
};

export const checkValue = (tags, tagName) => {
  var i = null;
  for (i = 0; tags.length > i; i += 1) {
    if (tags[i].value === tagName) {
      return true;
    }
  }
  return false;
};

export const checkText = (tags, tagName) => {
    var i = null;
    for (i = 0; tags.length > i; i += 1) {
        if (tags[i].text === tagName) {
            return true;
        }
    }
    return false;
}

export const buildAddPreQualArray = function (objectToAdd, IDSID) {
  var objpreQual = {};
  var preQualUpdateobj = {};
  var preQualUpdateArray = [];

  var newfromDate = new Date();
  var newtoDate = "99991231";
  // newfromDate = "20210727";
  
  preQualUpdateobj["carrier"] = objectToAdd.carrier;
  preQualUpdateobj["scacd"] = objectToAdd.scacd;
  preQualUpdateobj["originGeo"] = objectToAdd.originGeo;
  preQualUpdateobj["originValue"] = objectToAdd.originValue;
  preQualUpdateobj["destinationGeo"] = objectToAdd.destinationGeo;
  preQualUpdateobj["destinationValue"] = objectToAdd.destinationValue;
  preQualUpdateobj["modeOfTransport"] = objectToAdd.modeOfTransport;
  preQualUpdateobj["servType"] = objectToAdd.servType;
  preQualUpdateobj["qualified"] = objectToAdd.qualified;
  preQualUpdateobj["originCountry"] = objectToAdd.originCountry;
  preQualUpdateobj["destCountry"] = objectToAdd.destCountry;
  preQualUpdateobj["serviceLevel"] = objectToAdd.serviceLevel;
  preQualUpdateobj["primaryOwner"] = objectToAdd.primaryOwner;
  preQualUpdateobj["secondaryOwner"] = objectToAdd.secondaryOwner ? objectToAdd.secondaryOwner : "" ;
  preQualUpdateobj["allocatIndicator"] = objectToAdd.allocatIndicator;
  preQualUpdateobj["remarks"] = objectToAdd.remarks? objectToAdd.remarks : "";
  preQualUpdateobj["createdBy"] = IDSID;
  preQualUpdateobj["validFrom"] = newfromDate;
  preQualUpdateobj["validTo"] = newtoDate;
  // preQualUpdateobj["changedBy"] = "";
  // preQualUpdateobj["id"] = "";			
  //preQualUpdateArray.push(preQualUpdateobj);
  return preQualUpdateobj;

  //Commented for Bulk Upload
  /*objpreQual["action"] = "SUBM";
  objpreQual["dataList"] = preQualUpdateArray;					
  return objpreQual;*/
}